import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom'
import { FaStar, FaPhone, FaGlobe, FaEnvelope } from 'react-icons/fa';
const travelAgenciesData = [
  {
    id: 1,
    name: "Action Tours",
    logo: "https://bcassetcdn.com/assets/images/web/maker-home/how-logo-step-1@2x.webp",
    description: "Experience authentic Ethiopian adventures with our expert guides.",
    rating: 4.8,
    reviewCount: 127,
    specialties: ["Cultural Tours", "Historical Sites", "Adventure Tourism"],
    location: "Addis Ababa, Ethiopia",
    experience: "12+ years",
    highlights: [
      "Customized tour packages",
      "Professional local guides",
      "Competitive prices"
    ],
    contact: {
      phone: "+251-911-123456",
      email: "info@actiontours.com",
      website: "www.actiontours.com"
    }
  },
  {
    id: 2,
    name: "Yofi Ethiopia",
    logo: "https://bcassetcdn.com/assets/images/web/maker-home/how-logo-step-1@2x.webp",
    description: "Discover Ethiopia's hidden treasures with our expert-led tours.",
    rating: 4.9,
    reviewCount: 156,
    specialties: ["Heritage Tours", "Nature Expeditions", "Photography Tours"],
    location: "Addis Ababa, Ethiopia",
    experience: "10+ years",
    highlights: [
      "Luxury accommodations",
      "Multilingual guides",
      "24/7 support"
    ],
    contact: {
      phone: "+251-922-234567",
      email: "info@yofiethiopia.com",
      website: "www.yofiethiopia.com"
    }
  },
  {
    id: 1,
    name: "Action Tours",
    logo: "https://bcassetcdn.com/assets/images/web/maker-home/how-logo-step-1@2x.webp",
    description: "Experience authentic Ethiopian adventures with our expert guides.",
    rating: 4.8,
    reviewCount: 127,
    specialties: ["Cultural Tours", "Historical Sites", "Adventure Tourism"],
    location: "Addis Ababa, Ethiopia",
    experience: "12+ years",
    highlights: [
      "Customized tour packages",
      "Professional local guides",
      "Competitive prices"
    ],
    contact: {
      phone: "+251-911-123456",
      email: "info@actiontours.com",
      website: "www.actiontours.com"
    }
  },
  {
    id: 2,
    name: "Yofi Ethiopia",
    logo: "/logos/yofi-ethiopia.png",
    description: "Discover Ethiopia's hidden treasures with our expert-led tours.",
    rating: 4.9,
    reviewCount: 156,
    specialties: ["Heritage Tours", "Nature Expeditions", "Photography Tours"],
    location: "Addis Ababa, Ethiopia",
    experience: "10+ years",
    highlights: [
      "Luxury accommodations",
      "Multilingual guides",
      "24/7 support"
    ],
    contact: {
      phone: "+251-922-234567",
      email: "info@yofiethiopia.com",
      website: "www.yofiethiopia.com"
    }
  },
  {
    id: 1,
    name: "Action Tours",
    logo: "/logos/action-tours.png",
    description: "Experience authentic Ethiopian adventures with our expert guides.",
    rating: 4.8,
    reviewCount: 127,
    specialties: ["Cultural Tours", "Historical Sites", "Adventure Tourism"],
    location: "Addis Ababa, Ethiopia",
    experience: "12+ years",
    highlights: [
      "Customized tour packages",
      "Professional local guides",
      "Competitive prices"
    ],
    contact: {
      phone: "+251-911-123456",
      email: "info@actiontours.com",
      website: "www.actiontours.com"
    }
  },
  {
    id: 2,
    name: "Yofi Ethiopia",
    logo: "/logos/yofi-ethiopia.png",
    description: "Discover Ethiopia's hidden treasures with our expert-led tours.",
    rating: 4.9,
    reviewCount: 156,
    specialties: ["Heritage Tours", "Nature Expeditions", "Photography Tours"],
    location: "Addis Ababa, Ethiopia",
    experience: "10+ years",
    highlights: [
      "Luxury accommodations",
      "Multilingual guides",
      "24/7 support"
    ],
    contact: {
      phone: "+251-922-234567",
      email: "info@yofiethiopia.com",
      website: "www.yofiethiopia.com"
    }
  }
];

const TravelAgencies = () => {
  const navigate = useNavigate();
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });
 

  const handleEnquiry = (agencyId) => {
    navigate(`/singletravelagencies/${agencyId}`);
  };

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  return (
    <StyledAgenciesSection ref={ref}>
      <Container>
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={controls}
          variants={{
            visible: { opacity: 1, y: 0 }
          }}
          transition={{ duration: 0.8 }}
        >
          <div className="tag-line">
            <span>Trusted Partners</span>
          </div>
          <h2>Featured Tour Operators</h2>
          <p>Connect with Ethiopia's leading travel agencies for unforgettable experiences</p>
        </motion.div>

        <Row>
          {travelAgenciesData.map((agency, index) => (
            <Col lg={6} xl={4} key={agency.id}>
              <motion.div
                className="agency-card"
                initial={{ opacity: 0, y: 50 }}
                animate={controls}
                variants={{
                  visible: { 
                    opacity: 1, 
                    y: 0,
                    transition: { delay: index * 0.2 }
                  }
                }}
              >
                <div className="card-header">
                  <div className="logo-container">
                    <img src={agency.logo} alt={agency.name} />
                  </div>
                  <div className="rating">
                    <span className="rating-score">{agency.rating}</span>
                    <div className="stars">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} className={i < Math.floor(agency.rating) ? 'filled' : ''} />
                      ))}
                    </div>
                    <span className="review-count">({agency.reviewCount} reviews)</span>
                  </div>
                </div>

                <div className="card-body">
                  <h3>{agency.name}</h3>
                  <p className="description">{agency.description}</p>
                  
                  <div className="specialties">
                    {agency.specialties.map((specialty, i) => (
                      <span key={i} className="specialty-tag">{specialty}</span>
                    ))}
                  </div>

                  <div className="highlights">
                    {agency.highlights.map((highlight, i) => (
                      <div key={i} className="highlight-item">
                        <span className="checkmark">✓</span>
                        {highlight}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="card-footer">
                  <div className="contact-info">
                    <a href={`tel:${agency.contact.phone}`} className="contact-link">
                      <FaPhone /> Call
                    </a>
                    <a href={`mailto:${agency.contact.email}`} className="contact-link">
                      <FaEnvelope /> Email
                    </a>
                    <a href={`https://${agency.contact.website}`} className="contact-link" target="_blank" rel="noopener noreferrer">
                      <FaGlobe /> Website
                    </a>
                  </div>
                  <button
                  className="enquire-button"
                  onClick={() => handleEnquiry(agency.id)}
                >
                  Send Enquiry
                  <span className="button-icon">→</span>
                </button>
                </div>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </StyledAgenciesSection>
  );
};
const StyledAgenciesSection = styled.section`
  padding: 120px 0;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 0% 0%, rgba(45, 123, 168, 0.05) 0%, transparent 50%);
    pointer-events: none;
  }

  .section-header {
    text-align: center;
    margin-bottom: 4rem;

    .tag-line {
      display: inline-block;
      background: linear-gradient(45deg, #2d7ba8, #34495e);
      padding: 8px 20px;
      border-radius: 50px;
      margin-bottom: 1.5rem;
      
      span {
        color: white;
        font-size: 0.9rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 2px;
      }
    }

    h2 {
      font-size: 2.8rem;
      font-weight: 700;
      color: #1e293b;
      margin-bottom: 1rem;
    }

    p {
      color: #64748b;
      font-size: 1.1rem;
      max-width: 600px;
      margin: 0 auto;
    }
  }

  .agency-card {
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    margin-bottom: 30px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    overflow: hidden;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    }

    .card-header {
      padding: 1.5rem;
      border-bottom: 1px solid #f1f5f9;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .logo-container {
        width: 120px;
        height: 120px;
        border-radius: 15px;
        overflow: hidden;
        background: #f8fafc;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          padding: 1rem;
        }
      }

      .rating {
        text-align: right;

        .rating-score {
          font-size: 1.5rem;
          font-weight: 700;
          color: #2d7ba8;
        }

        .stars {
          color: #fbbf24;
          margin: 0.5rem 0;

          svg {
            margin-right: 2px;
            
            &.filled {
              color: #fbbf24;
            }
            
            &:not(.filled) {
              color: #e2e8f0;
            }
          }
        }

        .review-count {
          font-size: 0.9rem;
          color: #64748b;
        }
      }
    }

    .card-body {
      padding: 1.5rem;

      h3 {
        font-size: 1.5rem;
        font-weight: 600;
        color: #1e293b;
        margin-bottom: 1rem;
      }

      .description {
        color: #64748b;
        font-size: 1rem;
        line-height: 1.6;
        margin-bottom: 1.5rem;
      }

      .specialties {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-bottom: 1.5rem;

        .specialty-tag {
          background: #f1f5f9;
          color: #475569;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 500;
        }
      }

      .highlights {
        .highlight-item {
          display: flex;
          align-items: center;
          margin-bottom: 0.75rem;
          color: #475569;
          font-size: 0.95rem;

          .checkmark {
            color: #2d7ba8;
            font-weight: bold;
            margin-right: 0.75rem;
          }
        }
      }
    }

    .card-footer {
      padding: 1.5rem;
      border-top: 1px solid #f1f5f9;
      background: #f8fafc;

      .contact-info {
        display: flex;
        gap: 1rem;
        margin-bottom: 1rem;

        .contact-link {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #475569;
          text-decoration: none;
          font-size: 0.9rem;
          transition: color 0.3s ease;

          svg {
            color: #2d7ba8;
          }

          &:hover {
            color: #2d7ba8;
          }
        }
      }

      .enquire-button {
        width: 100%;
        padding: 1rem;
        background: linear-gradient(45deg, #2d7ba8, #34495e);
        color: white;
        border: none;
        border-radius: 10px;
        font-size: 1rem;
        font-weight: 500;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        transition: transform 0.3s ease;

        .button-icon {
          transition: transform 0.3s ease;
        }

        &:hover {
          transform: translateY(-2px);

          .button-icon {
            transform: translateX(5px);
          }
        }
      }
    }
  }

  @media (max-width: 1200px) {
    padding: 80px 0;

    .section-header {
      h2 {
        font-size: 2.3rem;
      }
    }
  }

  @media (max-width: 992px) {
    .agency-card {
      .card-header {
        flex-direction: column;
        text-align: center;

        .rating {
          text-align: center;
          margin-top: 1rem;
        }
      }

      .card-footer {
        .contact-info {
          flex-direction: column;
          align-items: center;
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 60px 0;

    .section-header {
      h2 {
        font-size: 2rem;
      }

      p {
        font-size: 1rem;
      }
    }

    .agency-card {
      .card-body {
        h3 {
          font-size: 1.3rem;
        }

        .specialties {
          justify-content: center;
        }
      }
    }
  }

  @keyframes float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
`;

export default TravelAgencies;